/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerResource
 */
export interface FreelancerResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    headline: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    pictureUrl?: string;
}

/**
 * Check if a given object implements the FreelancerResource interface.
 */
export function instanceOfFreelancerResource(value: object): value is FreelancerResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    return true;
}

export function FreelancerResourceFromJSON(json: any): FreelancerResource {
    return FreelancerResourceFromJSONTyped(json, false);
}

export function FreelancerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'companyId': json['companyId'],
        'fullName': json['fullName'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'headline': json['headline'],
        'pictureUrl': json['pictureUrl'] == null ? undefined : json['pictureUrl'],
    };
}

export function FreelancerResourceToJSON(value?: FreelancerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'profileId': value['profileId'],
        'companyId': value['companyId'],
        'fullName': value['fullName'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'headline': value['headline'],
        'pictureUrl': value['pictureUrl'],
    };
}

